import { render, staticRenderFns } from "./WeeklyBreakup.vue?vue&type=template&id=2cec904e&scoped=true&"
import script from "./WeeklyBreakup.vue?vue&type=script&lang=js&"
export * from "./WeeklyBreakup.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyBreakup.vue?vue&type=style&index=0&id=2cec904e&lang=scss&scoped=true&"
import style1 from "./WeeklyBreakup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec904e",
  null
  
)

export default component.exports